import { useState } from 'react'
import { Icon } from './Icons'

const inputClass = 'w-full rounded-xl border border-border bg-background px-4 py-3 pr-14 outline-none transition focus:border-secondary focus:ring-4 focus:ring-secondary/15'

// Campo de contraseña con mostrar/ocultar. El valor vive solo en el estado del formulario.
export default function PasswordField({ label, value, onChange, autoFocus, autoComplete = 'new-password', minLength = 8, describedBy }) {
  const [visible, setVisible] = useState(false)
  return (
    <label className="block text-sm font-medium text-text-primary">
      <span>{label}</span>
      <span className="relative mt-1.5 block">
        <input type={visible ? 'text' : 'password'} value={value} onChange={(event) => onChange(event.target.value)} autoComplete={autoComplete} minLength={minLength} required autoFocus={autoFocus} aria-describedby={describedBy} className={inputClass} />
        <button type="button" onClick={() => setVisible((current) => !current)} className="absolute right-1 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-lg text-text-secondary hover:text-primary" aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'} aria-pressed={visible}>
          <Icon name={visible ? 'eyeOff' : 'eye'} />
        </button>
      </span>
    </label>
  )
}
